import { render, staticRenderFns } from "./trans_bad.vue?vue&type=template&id=fc0de0e4&scoped=true"
import script from "./trans_bad.vue?vue&type=script&lang=js"
export * from "./trans_bad.vue?vue&type=script&lang=js"
import style0 from "./trans_bad.vue?vue&type=style&index=0&id=fc0de0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0de0e4",
  null
  
)

export default component.exports